module.exports = __webpack_public_path__ + "img/mater.82f87334.png";